import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';

import { crmConstants } from '..';

export const useCrmFacebookPagePipeDelete = () => {
  const qc = useQueryClient();

  return useMutation(
    async (id: number) => {
      const res = await $api.delete(`/v1/crm/facebook/page-pipe/${id}`);

      return res?.data?.data;
    },
    {
      onSuccess: async () => {
        await qc.invalidateQueries([crmConstants.queryKeys.CRM_FACEBOOK_APP_PIPE]);
      }
    }
  );
};
